import React, { Component } from 'react';
import ViewState from "./ViewState";
import Currencies from "./Currencies";

class Settings extends Component {
    componentWillMount() {
        this.props.appState.viewState = ViewState.about;
    }

    render() {
        return (
            <div className="settings box-shadow">
                <div className="row about-text">
                    <h2>Settings</h2>
                    <div className="currency-container">
                        <Currencies { ...this.props } />
                    </div>
                </div>
            </div>
        );
    }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/Settings.js